import styled from "styled-components";

// Card padrão do juiz
export const JudgeCard = styled.div`
  margin-bottom: 8px;
  padding: 8px;
  padding-left: 0;
  border-radius: 8px;
  background: #f5f7fa;
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`;

// Card do juiz com maior nota
export const JudgeCardMax = styled(JudgeCard)`
  background: #ffebee !important;
`;

// Card do juiz com menor nota
export const JudgeCardMin = styled(JudgeCard)`
  background: #ffebee !important;
`;
